/**
 * Helper method for getting attribute name - TODO: to be moved to external/shared helper
 *
 * @param {String} attributeCode
 * @param {String} optionId - value to get label for
 */
import { safeToString } from '@vue-storefront/core/helpers/primitives'
import get from 'lodash-es/get'

export function optionLabel (state, { attributeKey, searchBy = 'code', optionId }) {
  if (!state.labels) {
    state.labels = {}
  }

  // check cached attribute
  const attrCache = get(state, `labels.${attributeKey}.${optionId}`, null)
  if (attrCache) {
    return attrCache
  }

  const attr = state['list_by_' + searchBy][attributeKey]
  if (attr) {
    const opt = attr.options.find((op) => safeToString(op.value) === safeToString(optionId))

    if (opt) {
      if (!state.labels[attributeKey]) {
        state.labels[attributeKey] = {}
      }
      state.labels[attributeKey][optionId] = opt.label
      return opt ? opt.label : optionId
    } else {
      return optionId
    }
  } else {
    return optionId
  }
}
